import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { EnvironmentsModule } from './core-services/environments/environments.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core-services/AuthInterceptor';
import { MsalModule } from '@azure/msal-angular';
import { AuthModule } from './core-services/authentication/auth.module';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    importProvidersFrom(
      EnvironmentsModule.forChild(
        environment.production,
        environment.appInsightsConfig,
        environment.apiBaseUrl,
        environment.b2cConfig,
      ),
      BrowserAnimationsModule,
      AuthModule.forRoot(),
      MsalModule
    ),
    provideHttpClient(
      // DI-based interceptors must be explicitly enabled.
      withInterceptorsFromDi(),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
}).catch((err) => console.error('Bootstrap error:', err));

